import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../CustomCodes.redux';

const SelectCategory = () => {
    const dispatch = useDispatch(),
        value = useSelector((state) => state.customCodes.category);

    const handleChange = (e) => {
        dispatch(actions.setState({ category: e.target.value }));
    };

    const handleNext = () => {
        dispatch(actions.setState({ step: 'edit-code' }));
    };

    return (
        <div>
            <FormControl sx={{ width: '240px' }}>
                <InputLabel id="custom-code-select-category-label">Category</InputLabel>
                <Select
                    labelId="custom-code-select-category-label"
                    id="custom-code-select-category"
                    value={value}
                    label="Category"
                    onChange={handleChange}
                    sx={{ width: '100%' }}
                    fullWidth
                >
                    <MenuItem value="dx">Diagnostic</MenuItem>
                    <MenuItem value="tx">Treatment</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
};

export default SelectCategory;
